// react
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// components
import InputText from "./InputText";

let warningShown = false;

/**
 * THIS IS THE OLD INPUT. USE THE NEW ONE INSTEAD (InputText).
 * For now, this component just wraps the new InputText component.
 *
 * @deprecated use InputText in py-components instead
 */
const InputTextbox = ({
	id = undefined,
	disabled = false,
	focusOnRender = false,
	onChange = () => {},
	onKeyDown = () => {},
	onBlur = () => {},
	onFocus = () => {},
	onKeyUp = () => {},
	onEnter = () => {},
	placeholder = "",
	type = "text",
	name = "",
	className = "",
	style = {},
	value = "",
	textInputRef = null,
	maxLength = null,
	required = false,
	showWarning,
}) => {
	const localTextRef = useRef(null);

	useEffect(() => {
		if (!warningShown) {
			console.warn("TextInput is deprecated. Use InputText instead.");
			warningShown = true;
		}

		if (focusOnRender && localTextRef) {
			localTextRef.current?.focus();
		}
	}, [focusOnRender]);

	const focus = () => {
		if (localTextRef) {
			localTextRef.current?.focus();
		}
	};

	const handleChange = (value) => {
		onChange(value);
	};

	const handleFocus = () => {
		onFocus();
	};

	const handleBlur = () => {
		onBlur();
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			onEnter();
		}

		onKeyDown(e.key);
	};

	const handleKeyUp = (e) => {
		onKeyUp(e.key);
	};

	return (
		<InputText
			inputId={id}
			testId={"text-input"}
			ref={textInputRef || localTextRef}
			className={className}
			value={value}
			name={name}
			disabled={disabled}
			onBlur={handleBlur}
			onFocus={handleFocus}
			onChange={handleChange}
			placeholder={placeholder}
			onKeyUp={handleKeyUp}
			onKeyDown={handleKeyDown}
			style={{ borderBox: "box-sizing", width: "100%", ...style }}
			maxLength={maxLength}
			required={required}
			type={type}
			showWarning={showWarning}
		/>
	);
};

InputTextbox.propTypes = {
	id: PropTypes.string,
	disabled: PropTypes.bool,
	focusOnRender: PropTypes.bool,
	onChange: PropTypes.func,
	onKeyDown: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onKeyUp: PropTypes.func,
	onEnter: PropTypes.func,
	placeholder: PropTypes.string,
	type: PropTypes.string,
	name: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.object,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	textInputRef: PropTypes.object,
	maxLength: PropTypes.number,
	required: PropTypes.bool,
	showWarning: PropTypes.bool,
};

export default InputTextbox;
